import * as React from 'react';
import { themedText } from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context';

export interface MenuProps {
  className?: string;
  children: React.ReactNode;
}

export function Menu({ className, children }: MenuProps): JSX.Element {
  const theme = useThemeContext();

  return (
    <ul
      style={{
        display: 'flex',
        flexDirection: 'column',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        ...themedText(theme),
      }}
      className={className}
    >
      {children}
    </ul>
  );
}
